import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Grid } from '@mui/material';
import { useCallback, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import { HttpLCLS } from "./api/httpLCLS";
import { SeccionNuevoLCLSDatosOperacion } from "./components/SeccionNuevoLCLSDatosOperacion";
import { SeccionNuevoLCLSCuentas } from "./components/SeccionNuevoLCLSNuevoCuentas";
import { OperacionLCLSInsert } from "./types/dto";
import { OperacionLCLSFields } from "./types/fields";
import { FormOperacionLCLS, schemaFormOperacionLCLS } from "./types/types";
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion";

interface NuevoSistemaLCLSProps {
    codSistemaPrincipal: number
}

const NuevoSistemaLCLS = ({ codSistemaPrincipal }: NuevoSistemaLCLSProps) => {
    const { submitOperacion } = useSubmitOperacion();

    const formMethods = useForm<FormOperacionLCLS>({
        resolver: zodResolver(schemaFormOperacionLCLS),
        defaultValues: {
            [OperacionLCLSFields.FechaSolicitud]: new Date(),
            [OperacionLCLSFields.CodPais]: codSistemaPrincipal,
            [OperacionLCLSFields.Cuentas]: []
        }
    })

    const handleCrearOperacion = useCallback(
        (data: OperacionLCLSInsert) => {
            submitOperacion(data, {
                apiCall: HttpLCLS.post,
                codSistemaPrincipal,
            });
        },
        [codSistemaPrincipal, submitOperacion]
    );

    const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

    useEffect(() => {
        const onSend = () => formMethods.handleSubmit(data => handleCrearOperacion(data))
        setSendPromise(onSend)
    }, [formMethods, handleCrearOperacion])

    return (
        <Box>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <SeccionNuevoLCLSDatosOperacion formMethods={formMethods} codSistemaPrincipal={codSistemaPrincipal}
                        codSistema={codSistema}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SeccionNuevoLCLSCuentas formMethods={formMethods} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default NuevoSistemaLCLS
